export default "__VITE_ASSET__suwrEo9O__"